import type { CityConfig } from "../city-template/types";

export const merrimackConfig: CityConfig = {
  city: "Merrimack",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "merrimack",
  route: "/merrimack",
  title: "Emergency Passport Merrimack, NH | Fast Passport Renewal & Expedited Services",
  metaDescription: "Emergency passport and expedited passport services in Merrimack, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for southern New Hampshire and Nashua-Bedford corridor travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Merrimack, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Merrimack and southern New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Merrimack%20New%20Hampshire%20suburban%20townscape%20with%20the%20Anheuser-Busch%20brewery%2C%20Merrimack%20River%20winding%20through%20the%20town%2C%20green%20rolling%20hills%20and%20New%20England%20residential%20neighborhoods%2C%20warm%20summer%20day%20with%20blue%20sky%20and%20scattered%20clouds%2C%20clean%20and%20inviting%20suburban%20scene%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20natural%20green%20landscapes%2C%20professional%20photography%20with%20wide%20angle%20view&width=1800&height=700&seq=merrimack-nh-hero-001&orientation=landscape",
  heroImageAlt: "Merrimack New Hampshire suburban townscape with Merrimack River and green rolling hills",
  geoPosition: "42.8601;-71.4934",
  geoPlacename: "Merrimack, New Hampshire",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 50–70 minutes from Merrimack via Route 3 South",
  },
  nearbyCitiesZips: [
    { name: "Merrimack", zips: "03054" },
    { name: "Nashua", zips: "03060–03064" },
    { name: "Bedford", zips: "03110" },
    { name: "Amherst", zips: "03031" },
    { name: "Milford", zips: "03055" },
    { name: "Hollis", zips: "03049" },
    { name: "Litchfield", zips: "03052" },
    { name: "Hudson", zips: "03051" },
    { name: "Londonderry", zips: "03053" },
    { name: "Windham", zips: "03087" },
    { name: "Goffstown", zips: "03045" },
    { name: "Manchester", zips: "03101–03111" },
    { name: "Derry", zips: "03038" },
    { name: "Salem", zips: "03079" },
    { name: "Pelham", zips: "03076" },
    { name: "Hooksett", zips: "03106" },
    { name: "Concord", zips: "03301–03305" },
    { name: "Bow", zips: "03304" },
    { name: "Weare", zips: "03281" },
    { name: "New Boston", zips: "03070" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent southern New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Nashua", route: "/nashua" },
    { name: "Manchester", route: "/manchester" },
    { name: "Derry", route: "/derry" },
    { name: "Londonderry", route: "/londonderry" },
    { name: "Hudson", route: "/hudson" },
    { name: "Hampton", route: "/hampton" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Keene", route: "/keene" },
  ],
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Merrimack remotely via secure courier. We do not have a walk-in office in Merrimack — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for southern New Hampshire travelers.",
  fpcOfficeDistance: "Serving all of Hillsborough County and southern New Hampshire",
  serviceAreaIntro: "From the neighborhoods near the Merrimack Premium Outlets to the Reeds Ferry area, from the Naticook Lake district to the Baboosic Lake corridor — Fast Passport Center serves the entire Merrimack community. We regularly help travelers from Nashua, Bedford, Amherst, and Milford get their passports fast.",
  nearbyCitiesIntro: "We serve all Merrimack neighborhoods and nearby southern New Hampshire cities including Nashua, Bedford, Amherst, Milford, Hollis, Litchfield, Hudson, Londonderry, Windham, Goffstown, Manchester, Derry, Salem, Pelham, and Hooksett. If you are in the greater Merrimack area, we have you covered.",
  howItWorksIntro: "Most Merrimack travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Manchester-Boston Regional Airport (MHT) just 15 minutes away and easy access to Boston Logan, southern New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Merrimack and southern New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Merrimack? Here are the most common ones we hear from southern New Hampshire travelers.",
  processingIntro: "Merrimack travelers — Fidelity Investments and BAE Systems professionals traveling internationally on short notice, Merrimack Premium Outlets area families booking last-minute vacations, Nashua-Bedford corridor commuters, and southern New Hampshire residents needing urgent passport renewals — have several options for getting a passport fast. Here is how they compare, and why most Hillsborough County residents choose a U.S. Department of State registered passport courier for predictable, professional processing without driving to Boston.",
  localAreaIntro: [
    "Merrimack occupies a prime position in the Nashua-Bedford-Manchester triangle of southern New Hampshire, a suburban community that punches well above its weight economically thanks to the presence of major employers like Fidelity Investments — whose regional campus employs thousands — and BAE Systems, a global defense and aerospace company with significant operations in town. The workforce at these corporate campuses travels internationally with regularity: Fidelity's global financial services operations send employees to offices in Dublin, London, and Tokyo, while BAE Systems engineers and program managers travel to the United Kingdom, Australia, and partner facilities across Europe. When a BAE program manager learns on Tuesday that they need to be at a facility in Lancashire, England by Monday, the passport must be ready on a corporate schedule — not a government one.",
    "The education landscape in Merrimack creates its own passport urgency. Merrimack High School and Bishop Guertin High School in nearby Nashua both run international travel programs, from language immersion trips to service-learning expeditions. Thomas More College of Liberal Arts, located right in Merrimack, sends students to its Rome campus for semester-abroad programs requiring valid passports with sufficient remaining validity. Meanwhile, Merrimack families with students at the University of New Hampshire, Southern New Hampshire University, and Dartmouth College — all within an hour's drive — frequently navigate study-abroad passport requirements demanding processing speeds far beyond what the local post office can deliver.",
    "Manchester-Boston Regional Airport (MHT) is just 10 miles from Merrimack, making it the default departure point for most residents. With Southwest, American, Spirit, and seasonal international carriers serving MHT, Merrimack families book flights to warm-weather destinations with the assumption that their travel documents are in order. The airport's proximity is both a blessing and a trap: it makes international travel wonderfully accessible, but it also means passengers arrive at the terminal for a flight to Punta Cana or Toronto only to discover a passport emergency at the check-in counter. When that flight leaves in three hours and the next available appointment at the Boston Passport Agency is days away, the panic is real.",
    "Merrimack's family-first character — visible in the town's extensive park system, the annual Merrimack Sparkler 5K, and community events at Wasserman Park — means multi-generational travel is common. Families planning vacations to visit relatives in Quebec, where many Merrimack families have French-Canadian roots, discover that passport rules have tightened since their last trip. Parents booking Disney cruises from Port Canaveral or all-inclusive resorts in the Dominican Republic realize their children need passports too. The Merrimack Post Office on Daniel Webster Highway, the Town Clerk, and the Nashua Post Office all provide acceptance services — but when departure is days away, Fast Passport Center's 24–48 hour courier processing is the only reliable answer."
  ],
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Merrimack international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca W.",
      location: "Merrimack, NH",
      rating: 5,
      text: "My business trip to Tokyo was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Unbelievable service.",
      service: "Emergency Passport",
    },
    {
      name: "Christopher B.",
      location: "Nashua, NH",
      rating: 5,
      text: "Needed to renew for a family vacation to Spain. The process was incredibly smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Nicole A.",
      location: "Bedford, NH",
      rating: 5,
      text: "Lost my passport the week before my trip to Costa Rica. They walked me through the DS-64 process and got me a replacement in 48 hours. Incredible.",
      service: "Lost Passport",
    },
    {
      name: "Mark J.",
      location: "Amherst, NH",
      rating: 5,
      text: "As a frequent international traveler from southern New Hampshire, I can't afford passport delays. Fast Passport Center has been my go-to for years. Always reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "merrimack-nh-1",
      name: "Merrimack Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Hunter Rd",
      city: "Merrimack",
      state: "NH",
      zip: "03054",
      phone: "(603) 424-3610",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from downtown Merrimack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Merrimack. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "merrimack-nh-2",
      name: "Nashua Post Office — Downtown",
      type: "USPS Passport Acceptance Facility",
      address: "38 Spring St",
      city: "Nashua",
      state: "NH",
      zip: "03060",
      phone: "(603) 882-3331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6.5 miles from Merrimack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for southern New Hampshire. Extended hours available. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "merrimack-nh-3",
      name: "Bedford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Meetinghouse Rd",
      city: "Bedford",
      state: "NH",
      zip: "03110",
      phone: "(603) 472-5634",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "5.0 miles from Merrimack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bedford and eastern Merrimack residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "merrimack-nh-4",
      name: "Amherst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14 Amherst St",
      city: "Amherst",
      state: "NH",
      zip: "03031",
      phone: "(603) 673-3663",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "4.2 miles from Merrimack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for western Hillsborough County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "merrimack-nh-5",
      name: "Milford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Union Sq",
      city: "Milford",
      state: "NH",
      zip: "03055",
      phone: "(603) 673-1334",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "5.8 miles from Merrimack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Milford and Wilton residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "merrimack-nh-6",
      name: "Merrimack Town Clerk",
      type: "Town Clerk Passport Acceptance",
      address: "6 Baboosic Lake Rd",
      city: "Merrimack",
      state: "NH",
      zip: "03054",
      phone: "(603) 424-3651",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Town Hall",
      website: "https://www.merrimacknh.gov/",
      websiteLabel: "Merrimack Town Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Merrimack photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hillsborough County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Merrimack applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Merrimack families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Merrimack travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Merrimack." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Merrimack address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Merrimack before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Merrimack for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most southern New Hampshire travelers." },
    { q: "How fast can I renew my passport in Merrimack?", a: "Fast Passport Center offers fast passport renewal in Merrimack in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Merrimack in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Merrimack?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Merrimack residents." },
    { q: "Can I expedite a child passport in Merrimack?", a: "Yes. Fast Passport Center expedites child passports in Merrimack for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Merrimack with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Merrimack?", a: "With Fast Passport Center's emergency courier service, Merrimack travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Merrimack?", a: "Popular options include the Merrimack Post Office (03054), Nashua Downtown Post Office (03060), Bedford Post Office (03110), and Merrimack Town Clerk (03054). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Merrimack?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Nashua or Bedford?", a: "We serve all of southern New Hampshire including Nashua, Bedford, Amherst, Milford, Hollis, Litchfield, Hudson, Londonderry, Windham, Goffstown, Manchester, Derry, Salem, and Pelham. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Merrimack?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Merrimack", address: "1 Premium Outlets Blvd, Merrimack, NH 03054", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Merrimack", address: "300 Daniel Webster Hwy, Merrimack, NH 03054", hours: "Mon–Sun: 7AM–11PM" },
    { name: "UPS Store — Merrimack", address: "1 Daniel Webster Hwy, Merrimack, NH 03054", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Nashua", address: "220 Daniel Webster Hwy, Nashua, NH 03060", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Nashua", address: "230 Main St, Nashua, NH 03060", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Nashua", address: "222 Main St, Nashua, NH 03060", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Costco — Nashua", address: "255 Main St, Nashua, NH 03060", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
    { name: "Walgreens — Bedford", address: "5 Meetinghouse Rd, Bedford, NH 03110", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    { name: "DMV — Nashua", address: "33 Main St, Nashua, NH 03060", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services. Appointment required.", featured: true },
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Epping", address: "101 Calef Hwy, Epping, NH 03042", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Keene", address: "12 West St, Keene, NH 03431", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for southwestern New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "10 miles from Merrimack", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Merrimack travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "55 miles from Merrimack", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "PSM", name: "Portsmouth International Airport", distance: "40 miles from Merrimack", address: "50 Terminal Way, Portsmouth, NH 03801", note: "Regional commercial airport with seasonal flights to Florida and international destinations.", flightUrl: "https://www.flypsm.com/", flightLabel: "PSM Flight Info", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the New Hampshire Division of Vital Records Administration. Online, mail, or in-person options for Hillsborough County residents.", url: "https://www.sos.nh.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through NH Division of Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.sos.nh.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Merrimack Town Clerk. Certified copies available for name changes.", url: "https://www.merrimacknh.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Hillsborough County Superior Court. Required for name change passport corrections.", url: "https://www.courts.state.nh.us/" },
  ],
};